import { doublePriceEndDate } from "../Config/Consts";
import { euroToKnConverter, knToEuroConverter } from "./CurrencyConverter";

export const euroCurrencyFormatter = value => {
  const realPrice = new Intl.NumberFormat("hr", {
    style: "currency",
    currency: "EUR",
  }).format(Number(value));

  const convertedPrice =
    " (" +
    new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "HRK",
    }).format(euroToKnConverter(value)) +
    ")";

  const price = realPrice + convertedPrice;

  const showDoublePrice = doublePriceEndDate > new Date();
  return showDoublePrice ? price : realPrice;
};
export const knCurrencyFormatter = value => {
  const realPrice = new Intl.NumberFormat("hr", {
    style: "currency",
    currency: "HRK",
  }).format(Number(value));

  const convertedPrice =
    " (" +
    new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(knToEuroConverter(value)) +
    ")";

  const price = realPrice + convertedPrice;

  const showDoublePrice = doublePriceEndDate > new Date();
  return showDoublePrice ? price : realPrice;
};
